<div>
	<ToneJs mainObj={mainObj}/>
	<Orca   mainObj={mainObj}/>
	
	<button
		style="margin-top: 1rem;"
		on:click={stop}>stop ( redo )</button>
</div>

<script>
	import ToneJs from "./ToneJs.svelte";
	import Orca from "./Orca.svelte";

	// 渡されてきたやつら
	export let mainObj;

	function stop(){
		// 一旦
		location.reload();
	}
	
</script>